import { useEffect } from "react";

/**
 * Feature 7 - Disable Drag & Drop.
 *
 * Prevents dragging text, images, and PDFs out of the viewer by blocking
 * `dragstart` and `drop` on the target. When `enabled` is false, no-op.
 *
 * @param {object} opts
 * @param {boolean} opts.enabled
 * @param {() => HTMLElement|null} [opts.getTarget]
 * @param {() => void} [opts.onBlocked]
 */
export function useDragDropGuard({ enabled, getTarget, onBlocked } = {}) {
  useEffect(() => {
    if (!enabled) return undefined;
    const target = (getTarget && getTarget()) || document;

    const handler = (e) => {
      e.preventDefault();
      if (typeof onBlocked === "function") onBlocked();
      return false;
    };

    target.addEventListener("dragstart", handler, false);
    target.addEventListener("drop", handler, false);

    return () => {
      target.removeEventListener("dragstart", handler, false);
      target.removeEventListener("drop", handler, false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
}

export default useDragDropGuard;
